<template lang="pug">
  v-container.white(style="max-width:600px")
    v-row(v-for="(section, index) in content.sections" :key="index + '-section'" :style="section.styles")
      v-col.py-0(v-for="(container, index) in section.containers" :key="index + '-container'" :style="container.styles" :cols="container.cols")
        TextView(v-if="container.content.type == 'text'" :content="container.content")
        ImageView(v-if="container.content.type == 'image'" :content="container.content")
        VideoView(v-if="container.content.type == 'video'" :content="container.content")

</template>

<script>
import TextView from '@/components/pageeditor/TextView.vue'
import ImageView from '@/components/pageeditor/ImageView.vue'
import VideoView from '@/components/pageeditor/VideoView.vue'
export default {
  components: { TextView, ImageView, VideoView },
  data: () => ({
    content: {
      version: 1.0,
      sections: [
        {
          styles: 'margin-bottom: 16px',
          containers: [
            {
              styles: '',
              cols: 12,
              content: {
                styles: 'text-align: center; font-weight: bold; font-size: 28px;',
                type: 'text',
                value: 'Adidas Originals'
              }
            }
          ]
        },
        {
          styles: 'margin-bottom: 16px',
          containers: [
            {
              styles: 'text-align: center;',
              cols: 12,
              content: {
                styles: 'text-align: center;',
                type: 'video',
                value: {
                  src: "https://www.youtube.com/embed/SMJcXEyPA6c?&wmode=opaque&rel=0"
                }
              }
            }
          ]
        },
        {
          styles: '',
          containers: [
            {
              styles: 'white-space: pre-wrap;',
              cols: 6,
              content: {
                styles: 'text-align: justify; font-size: 14px;',
                type: 'text',
                value: 'Sport keeps us fit. Keeps you mindful. Brings us together. Through sport we have the power to change lives. Whether it is through stories of inspiring athletes. Helping you to get up and get moving. Sportswear featuring the latest technologies, to up your performance. Sport keeps us fit. Keeps you mindful. Brings us together. Through sport we have the power to change lives. Whether it is through stories of inspiring athletes.'
              }
            },
            {
              styles: 'padding-left: 0px;',
              cols: 6,
              content: {
                styles: 'background-color:white;',
                type: 'image',
                value: { 
                  src:"https://images.unsplash.com/photo-1552933529-e359b2477252?ixlib=rb-1.2.1&w=1000&q=80",
                  caption: "Adidas Cat"
                }
              }
            }
          ]
        }
      ]
    }
  }),
  mounted () {
    this.disablePageZoom()
  },
  methods: {
    disablePageZoom () {
      const tag = document.createElement('meta')
      tag.setAttribute('name','viewport')
      tag.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
      document.head.appendChild(tag)
    }
  }
}
</script>

<style scoped></style>
